const HTTPS_PROTOCOL = 'https:';
const MAX_URL_LENGTH = 2048;

export const CHECKLIST_URL_PREFIX = 'https://yamano-media.com/blog/mountain-checker-app/';

export const PROFILE_LINK_HOSTS = {
  yamapLink: ['yamap.com'],
  yamarecoLink: ['yamareco.com'],
  twitterLink: ['x.com', 'twitter.com'],
  youtubeLink: ['youtube.com', 'youtu.be'],
  instagramLink: ['instagram.com'],
};

export const FIELD_LABELS = {
  yamapLink: 'YAMAP',
  yamarecoLink: 'ヤマレコ',
  twitterLink: 'X(Twitter)',
  youtubeLink: 'YouTube',
  instagramLink: 'Instagram',
  homepage: 'ホームページ',
  checklistUrl: '装備チェックリストURL',
};

export function isAllowedHost(hostname, allowedHosts = []) {
  const normalized = String(hostname || '').toLowerCase();
  return allowedHosts.some((host) => normalized === host || normalized.endsWith(`.${host}`));
}

export function validateHttpsUrl(value, fieldName, allowedHosts = []) {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (!raw) return { isValid: true, value: '' };

  if (raw.length > MAX_URL_LENGTH) {
    return { isValid: false, message: `${FIELD_LABELS[fieldName] || fieldName}は2048文字以内で入力してください。` };
  }

  let parsed;
  try {
    parsed = new URL(raw);
  } catch (error) {
    return { isValid: false, message: `${FIELD_LABELS[fieldName] || fieldName}は正しいURL形式で入力してください。` };
  }

  if (parsed.protocol !== HTTPS_PROTOCOL || parsed.username || parsed.password) {
    return { isValid: false, message: `${FIELD_LABELS[fieldName] || fieldName}は https:// から始まるURLを入力してください。` };
  }

  if (allowedHosts.length > 0 && !isAllowedHost(parsed.hostname, allowedHosts)) {
    return { isValid: false, message: `${FIELD_LABELS[fieldName] || fieldName}に指定できないドメインです。` };
  }

  return { isValid: true, value: parsed.toString() };
}

export function validateChecklistUrl(value) {
  const result = validateHttpsUrl(value, 'checklistUrl', ['yamano-media.com']);
  if (!result.isValid || !result.value) return result;
  if (!result.value.startsWith(CHECKLIST_URL_PREFIX)) {
    return {
      isValid: false,
      message: `装備チェックリストURLは ${CHECKLIST_URL_PREFIX} から始まるURLのみ入力できます。`,
    };
  }
  return result;
}

